
import { apiSlice } from '../../../api/apiSlice';
import * as constants from '../../../constants';

export const edsExceptionScorecardAssignmentSlice = apiSlice.injectEndpoints({
    endpoints : (builder : any) => ({
        createScorecardGroupAssign: builder.mutation({
            query: (arg: any) => ({
                url: constants.ASSIGN_SCORECARD_GROUP,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['ScExAssignment'],
        }),
        getScorecardTeammember: builder.query({
            query: (arg: any) => {
                const { scorecardVersionId } = arg;
                return {
                    url: constants.SCORECARD_TEAM_MEMBER,
                    params: { scorecardVersionId },
                };
            }
           
        }),
        getScorecardAssignOverrides: builder.query({
            query: (arg: any) => {
                const { scorecardId } = arg;
                return {
                    url: constants.SCORECARD_ASSIGN_OVERRIDE,
                    params: { scorecardId },
                };
            },
            providesTags : ['ScExAssignment']
        }),
        deleteScoreCardAssignOverridesGroup: builder.mutation({
            query: (arg: any) => ({
                url: constants.DELETE_GROUP_ASSIGN_SCORECARD,
                method: 'PUT',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),

            invalidatesTags: ['ScExAssignment'],
        }),
    })
})

export const {
    useCreateScorecardGroupAssignMutation,
    useGetScorecardTeammemberQuery,
    useGetScorecardAssignOverridesQuery,
    useDeleteScoreCardAssignOverridesGroupMutation
} = edsExceptionScorecardAssignmentSlice